import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  stroke?: string;
  className?: string;
}

const HallowShareIcon: React.FC<Props> = ({
  stroke = '#991B1B',
  className
}) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...(className
        ? { className }
        : { height: 12, width: 12 })}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="m4.295 6.755 3.415 1.99m-.005-5.49-3.41 1.99M10.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M4.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);
export { HallowShareIcon };
